import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, openFile, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './plans.reducer';

export const PlansDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const plansEntity = useAppSelector(state => state.plans.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="plansDetailsHeading">
          <Translate contentKey="fitengineerBackendV2App.plans.detail.title">Plans</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{plansEntity.id}</dd>
          <dt>
            <span id="planTitle">
              <Translate contentKey="fitengineerBackendV2App.plans.planTitle">Plan Title</Translate>
            </span>
          </dt>
          <dd>{plansEntity.planTitle}</dd>
          <dt>
            <span id="planPrice">
              <Translate contentKey="fitengineerBackendV2App.plans.planPrice">Plan Price</Translate>
            </span>
          </dt>
          <dd>{plansEntity.planPrice}</dd>
          <dt>
            <span id="planDescription">
              <Translate contentKey="fitengineerBackendV2App.plans.planDescription">Plan Description</Translate>
            </span>
          </dt>
          <dd>{plansEntity.planDescription}</dd>
          <dt>
            <span id="planLogo">
              <Translate contentKey="fitengineerBackendV2App.plans.planLogo">Plan Logo</Translate>
            </span>
          </dt>
          <dd>
            {plansEntity.planLogo ? (
              <div>
                {plansEntity.planLogoContentType ? (
                  <a onClick={openFile(plansEntity.planLogoContentType, plansEntity.planLogo)}>
                    <img src={`data:${plansEntity.planLogoContentType};base64,${plansEntity.planLogo}`} style={{ maxHeight: '30px' }} />
                  </a>
                ) : null}
                <span>
                  {plansEntity.planLogoContentType}, {byteSize(plansEntity.planLogo)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <span id="planSuitableFor">
              <Translate contentKey="fitengineerBackendV2App.plans.planSuitableFor">Plan Suitable For</Translate>
            </span>
          </dt>
          <dd>{plansEntity.planSuitableFor}</dd>
          <dt>
            <Translate contentKey="fitengineerBackendV2App.plans.planCategory">Plan Category</Translate>
          </dt>
          <dd>{plansEntity.planCategory ? plansEntity.planCategory.planCategory : ''}</dd>
        </dl>
        <Button tag={Link} to="/plans" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/plans/${plansEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PlansDetail;
